import type {ReactElement} from 'react';
import {ControlledSlider} from '@Components/controlled-slider';
import {useAppSelector} from '@/hooks';
import './page-slider.scss';
import {onPosterPause} from '@Components/poster-editor/library/poster-editor-library';
import {getPageCurrentTime, isPageVideo} from '@Components/poster-editor/poster-editor-reducer';
import {getPageDuration} from '@Libraries/page-duration.library';

interface PageSliderProps {
  pageId: string;
}

export function PageSlider({...props}: PageSliderProps): ReactElement | null {
  const pageDuration = useAppSelector((state) => {
    const page = state.posterEditor.posterObject?.pages?.pagesHashMap[props.pageId];
    return page ? getPageDuration(page) : undefined;
  });
  const currentTime = useAppSelector((state) => getPageCurrentTime(state, props.pageId));
  const isVideoPage = useAppSelector((state) => isPageVideo(state, props.pageId));
  const isDesktopTimelineToggleOn = useAppSelector((state) => {
    return state.posterEditor.isDesktopTimelineToggleOn;
  });
  const seekPage = (newValue: number | number[]): void => {
    const targetPage = window.posterEditor?.whiteboard?.pages.pagesHashMap[props.pageId];
    if (!targetPage) {
      return;
    }
    void targetPage.seek(newValue as number);
  };

  // The open timeline (desktop bottom bar, mobile panel) hides this slider and shows its own playhead, so rendering it would only re-run rc-slider on every playback tick.
  if (!pageDuration || !isVideoPage || isDesktopTimelineToggleOn) {
    return null;
  }

  const onSlide = (value: number): void => {
    onPosterPause();
    seekPage(value);
  };

  return <ControlledSlider className="page-slider" value={currentTime} step={0.01} min={0} max={pageDuration} onSlide={onSlide} />;
}
